import type { AnalyticsProvider } from "../common/types";

let provider: AnalyticsProvider = { track: () => {} };

export function setAnalyticsProvider(p: AnalyticsProvider) {
  provider = p;
}

export function identify(user: { id: string } & Record<string, unknown>) {
  provider.identify?.(user);
}

export function track(event: string, properties?: Record<string, unknown>) {
  provider.track(event, properties);
}

export function trackError(
  event: string,
  properties?: Record<string, unknown>,
  level: "error" | "warn" = "error",
) {
  provider.trackError?.(event, properties, level);
}
